export const APPSTORE_PREFIX = 'hp-appstore';
export const BANNER_PREFIX = 'content-card-button'; // used by func testing only
export const QUICKLINKS_PREFIX = 'hp-ql';
export const PRODUCTQUICKLINKS_PREFIX = 'hp-pql';
export const TRUSTPILOT_PREFIX = 'hp-tp';
export const TAIL_PREFIX = 'hp-tail';
export const REWARDS_PREFIX = 'hp-rewards';
export const OFFERS_PREFIX = 'hp-offers';
